import React from 'react';
// import Helmet from 'react-helmet'
// import Layout from '../../components/Layout'
// import Background from '../../components/Background'
// import PrismicDOM from 'prismic-dom'
import {RichText} from 'prismic-reactjs';
import Link from 'gatsby-link'
// import {navigateTo} from 'gatsby-link'
import styled from 'styled-components'
import Grid from 'styled-components-grid'
import { findUrl } from './Navigation.js'
import {
  FullImage, 
  opacity, 
  SpacedGridUnit, 
  OpacSpacedGridUnit,
  LinkPlus,
  Box
} from './Styles'
import {Margin, Padding} from 'styled-components-spacing'
import ImageLink from './ImageLink'

class Section extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { primary, index, slug } = this.props;
    return (
      <Margin horizontal={2} key={`item-content-${index}`}>
        <Grid reverse={index%2?true:false} valign={{mobile:index%2 ? 'bottom' : 'top',tablet:'center'}}>
          {primary.image.url && primary.link_to_a_content.data ? (
            <ImageLink
              key={primary.slug}
              image={primary.image.url}
              alt={primary.image.alt}
              to={findUrl(primary.link_to_a_content.slug, this.props.pagesUrl)}
              name={primary.link_to_a_content.data.title[0].text}
            />
          ) : (
            <Grid.Unit size={1/3}>
              <FullImage 
                src={primary.image.url} 
                alt={primary.image.alt}
                sizes="250px"
                srcSet={[
                  primary.image.xl ? `${primary.image.xl.url} 640w` : null,
                  primary.image.md ? `${primary.image.md.url} 450w` : null,
                  primary.image.sm ? `${primary.image.sm.url} 260w` : null,
                ]} />
            </Grid.Unit>
          )}
          <Grid.Unit size={2/3}>
            <Margin all={{mobile:0, tablet:2}}>
              <OpacSpacedGridUnit>
                {RichText.render(primary.text_content)}
                {primary.link_to_a_content && primary.link_to_a_content.data && 
                  <Box textAlign='right' position="absolute" width={1} left="0" bottom="0" p={2}>
                    <LinkPlus to={findUrl(primary.link_to_a_content.slug, this.props.pagesUrl)}>
                      {/* primary.link_to_a_content.data.title[0].text */}
                      +
                    </LinkPlus>
                  </Box>
                }
              </OpacSpacedGridUnit>
            </Margin>
          </Grid.Unit>
        </Grid>
      </Margin>
    )
  }
}

export default Section;


// WEBPACK FOOTER //
// ./src/components/Section.js